import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';
import { logDevError, updateErrorMessage } from 'shared/alerts';

export const HOLD_BEST_AVAILABLE = gql`
  mutation HoldBestAvailable($input: HoldBestAvailableInput!) {
    holdBestAvailable(input: $input) {
      label
      ticketType
    }
  }
`;

export function useHoldBestAvailable() {
  const [holdBestAvailableMutation] = useMutation(HOLD_BEST_AVAILABLE);

  const holdBestAvailable = useCallback(
    async (input) => {
      try {
        const response = await holdBestAvailableMutation({
          variables: { input },
          onError: () => updateErrorMessage('Error holding best available'),
        });

        return response;
      } catch (error) {
        logDevError(error);
        updateErrorMessage('Error holding best available');
      }
    },
    [holdBestAvailableMutation]
  );

  return holdBestAvailable;
}
